import { CheckPageParams } from "@/pages/check/CheckPage";
import router from "@/router";
import { Location, Route } from "vue-router";

export type PageNames = "pay" | "writing" | "aiCopywriter" | "check";

export const pageNames: { [key in PageNames]: key } = {
  check: "check",
  pay: "pay",
  writing: "writing",
  aiCopywriter: "aiCopywriter",
};

export const pagePaths: { [key in PageNames]: string } = {
  check: "/check",
  pay: "/pay",
  writing: "/writing",
  aiCopywriter: "/aiCopywriter",
};

/**
 * 封装调用{@link router.push}方法，添加参数类型
 * @param name 路由名称
 * @param params 路由参数
 * @param location 其他路由参数，这里的name和params字段将被忽略
 */
function pushTo(
  name: "check",
  params?: CheckPageParams,
  location?: Omit<Location, "name" | "params">
): Promise<Route>;
function pushTo(
  name: Exclude<PageNames, "check">,
  params?: { [key: string]: string },
  location?: Omit<Location, "name" | "params">
): Promise<Route>;
function pushTo(
  name: PageNames,
  params: { [key: string]: string } = {},
  location: Omit<Location, "name" | "params"> = {}
): Promise<Route> {
  return router.push({ ...location, name, params });
}

export const RouterTools = {
  pageNames,
  pagePaths,
  pushTo,
};
